import { put, call } from 'redux-saga/effects'
import { submitToApi } from 'awsApi'
import ManagersActions from '../models/managers'
import { getAccessToAllPages } from './transform/manager'
import { URL } from './endpoints'

export function* addManager({ body, callback }) {
    try {
        const { message } = yield call(() =>
            submitToApi({ body, method: 'POST', path: URL.SUPPLIERS.V3_SUPPLIERS_INVITE_SUPPLIER_USER, url: URL.SUPPLIERS.BASE })
        )
        yield put(ManagersActions.addManagerSuccess())
        yield put(ManagersActions.getManagers(body.clientId))
        callback(message, 'success')
    } catch (error) {
        yield put(ManagersActions.addManagerFailure())
        callback(error, 'error')
    }
}

export function* getManagers() {
    try {
        const { supplierId } = JSON.parse(localStorage.getItem('supplier'))

        const { message, payload } = yield call(() =>
            submitToApi({
                path: URL.SUPPLIERS.V3_SUPPLIERS_GET_SUPPLIER_USER,
                query: { supplierId },
                url: URL.SUPPLIERS.BASE,
            })
        )
        if (!payload.data.length) {
            return yield put(ManagersActions.getManagersFailure(message))
        }

        const managers = payload.data.map(manager => getAccessToAllPages(manager))
        yield put(ManagersActions.getManagersSuccess(managers || []))
    } catch (error) {
        yield put(ManagersActions.getManagersFailure(error))
    }
}

export function* updateManager({ body, callback }) {
    try {
        const { message } = yield call(() =>
            submitToApi({ method: 'PUT', path: URL.SUPPLIERS.V3_SUPPLIERS_ENABLE_DISABLE_SUPPLIER_USER, query: body, url: URL.SUPPLIERS.BASE })
        )
        yield put(ManagersActions.updateManagerSuccess(body.supplierAdminId, body.state === 'enable' ? 'Complete' : 'Disabled'))
        callback(message, 'success')
    } catch (error) {
        yield put(ManagersActions.updateManagerFailure())
        callback(error, 'error')
    }
}

export function* updateManagerRole({ body, email, key, callback }) {
    try {
        const { message, payload } = yield call(() =>
            submitToApi({
                body,
                method: 'PUT',
                path: URL.SUPPLIERS.V3_SUPPLIERS_ENABLE_DISABLE_SUPPLIER_ROLES,
                query: { email },
                url: URL.SUPPLIERS.BASE,
            })
        )
        yield put(ManagersActions.updateManagerRoleSuccess(body, email, key))
        callback(body, email, key)
    } catch (error) {
        yield put(ManagersActions.updateManagerRoleFailure(error))
    }
}
